import L from 'leaflet';
import { legendas_mapa_indicadores } from '../../../../../../../../../../../Components/ordemLaboratorio/mapaFertilidade/components/cardLegenda/meta';

export function obterFitBound(talhoes_selecionados: { cod_talhao: number, nome_talhao: string, coordenadas: { latitude?: number, longitude?: number, lat?:number, lng?:number }[] }[]) {

    let multi_coordenadas = (talhoes_selecionados.map(i => i.coordenadas));

    let multi_coord_padrao = multi_coordenadas.map((item) => {
        let format = item.map(i => { return { lat: i.latitude??i.lat, lng: i.longitude??i.lng } })
        return format;
    })

    // @ts-ignore
    const polygonFit = new L.Polygon(multi_coord_padrao.flat(), {})
    const fitBounds = polygonFit.getBounds();

    return fitBounds;
};


export function listaCoordenadasTalhoes(talhoes_selecionados: { cod_talhao: number, nome_talhao: string, coordenadas: { latitude: number, longitude: number, lat?:number, lng?:number }[] }[]) {

    let multi_coordenadas = (talhoes_selecionados.map(i => i.coordenadas));

    let multi_coord_padrao = multi_coordenadas.map((item) => {
        let format = item.map(i => { return { lat: i.latitude??i.lat, lng: i.longitude??i.lng } })
        return format;
    })

    return multi_coord_padrao;
};

export function obterNomesTalhoes(talhoes_selecionados: { cod_talhao: number, nome_talhao: string, coordenadas: { latitude: number, longitude: number }[] }[]) {
    let nomes_talhoes = (talhoes_selecionados.map(i => i.nome_talhao));

    return String(nomes_talhoes?.join(','));
}

type typeTalhoesSelecionados = { cod_talhao: number, nome_talhao: string, talhao_area: number, coordenadas: { latitude: number, longitude: number }[]};

export function tabela_info_cliente(nome_cliente: string, nome_propriedade: string, talhoes_selecionados: typeTalhoesSelecionados[]): { descricao: 'Cliente' | 'Propriedade' | 'Área', valor: string }[] {
    let area_talhoes = talhoes_selecionados?.reduce((acc, item)=> acc + item.talhao_area, 0)
    return [
        { descricao: 'Cliente', valor: nome_cliente },
        { descricao: 'Propriedade', valor: nome_propriedade },
        { descricao: 'Área', valor: `${area_talhoes?.toFixed(2)} ha` },
    ];
};

type typeTabelaDetalhes = {
    talhoes: string,
    safra: string,
    profundidade: string,
    nome_elemento: string,
    isPrescricao: boolean,
    isIndicadores: boolean,
    nome_calcario_propriedade: string
};
export function tabela_detalhes(detalhes: typeTabelaDetalhes) {
    let { talhoes, safra, profundidade, nome_elemento, isPrescricao, isIndicadores, nome_calcario_propriedade } = detalhes;

    function nomeDescricaoProfundidade(elemento_analisado: string): 'Calcário utilizado' | 'Tipo de mapa' | 'Profundidade' {
        if (elemento_analisado?.startsWith('Calcário')) return 'Calcário utilizado';
        return (isPrescricao || isIndicadores) ? 'Tipo de mapa' : 'Profundidade'
    }
    function valorDetalheProfundidade(elemento_analisado: string) {
        if (elemento_analisado?.startsWith('Calcário')) return nome_calcario_propriedade;
        return String(profundidade)?.replace('micro', '00-20')?.replace("prescricoes", 'prescrições')
    }

    return [
        { id: 0, descricao: 'Talhões', valor: talhoes },
        { id: 1, descricao: 'Safra', valor: safra },
        { id: 2, descricao: nomeDescricaoProfundidade('null'), valor: valorDetalheProfundidade('null') },
        { id: 3, descricao: (isPrescricao) ? 'Mapa recomendado' : 'Elemento analisado', valor: nome_elemento, small: true },
        { id: 4, descricao: nomeDescricaoProfundidade(nome_elemento), valor: valorDetalheProfundidade(nome_elemento) },
    ]?.filter((item) => {
        return (nome_elemento?.startsWith('Calcário')) ? item.id !== 2 : item.id !== 4
    });
}

type typeTabelaValores = {
    interpretado_minimo: number,
    interpretado_media: number,
    interpretado_maximo: number,
    isCorInvertida: boolean,
    isInterpretado: boolean,
    isIndicadores: boolean,
    isPrescricao: boolean
    cod_elemento: number,
    unidade: string,
    nota_minima: string,
    nota_media: string,
    nota_maxima: string,
    cores_do_mapa: string[],
    area_talhoes: number
}
function isMedia(tipo: "Média" | "Máxima", interpretado_media: number, interpretado_maximo: number): number {
    if (tipo==='Média') {
        return interpretado_media;
    }
    return interpretado_maximo;
}
function isInvertido(cor_invertida: boolean, valor_verdade: number|string, valor_falso: number|string) {
    return cor_invertida ? valor_verdade : valor_falso;
}
export function legendaClassificacao(tipo: 'Mínima'|'Média'|'Máxima', notas_interp: typeTabelaValores): {classificacao: string, hexadecimal: string} { //NOSONAR

    let { interpretado_minimo, interpretado_media, interpretado_maximo, isInterpretado, isCorInvertida, cod_elemento } = notas_interp;

    let valor_para_comparar = tipo === 'Mínima' ? interpretado_minimo : isMedia(tipo, interpretado_media, interpretado_maximo);

    let cor_base: string[] = ['#2ecc71', '#b0f13c', '#f0ff00', '#ff9a00', '#e22626'];

    if (!isInterpretado && tipo==='Mínima') {
        return {classificacao: '', hexadecimal: (isCorInvertida ? "#2ecc71" : '#e22626')}
    }
    if (!isInterpretado && tipo==='Média') {
        return {classificacao: '', hexadecimal: '#f0ff00'}
    }
    if (!isInterpretado && tipo==='Máxima') {
        return {classificacao: '', hexadecimal: (isCorInvertida ? "#e22626" : '#2ecc71')}
    }

    function classicacaoEspecialIndicadores(hexadecimal_comparativo: string) {
        let legendas = legendas_mapa_indicadores?.[cod_elemento];
        const cartaEncontrada = legendas?.find(item => item?.hexadecimal === hexadecimal_comparativo);

        return cartaEncontrada ? cartaEncontrada.carta : "";
    }
    
    if (valor_para_comparar <=20) { 
        return {
            classificacao: ([33,34,38]?.indexOf(cod_elemento) > -1) ? classicacaoEspecialIndicadores(cor_base?.[isInvertido(isCorInvertida, 0, 4)]) : 'Muito baixo', 
            hexadecimal: isInterpretado ? (cor_base?.[isInvertido(isCorInvertida, 0, 4)]) : (isInvertido(isCorInvertida, '#2ecc71', '#e22626'))
        };    
    }
    else if (valor_para_comparar <= 40) {
        return {
            classificacao: ([33,34,38]?.indexOf(cod_elemento) > -1) ? classicacaoEspecialIndicadores(cor_base?.[isInvertido(isCorInvertida, 1, 3)]) : 'Baixo', 
            hexadecimal: isInterpretado ? (cor_base?.[isInvertido(isCorInvertida, 1, 3)]) : (isInvertido(isCorInvertida, "#2ecc71", '#e22626'))
        };    
    }
    else if (valor_para_comparar <= 60) {
        return {
            classificacao: ([33,34,38]?.indexOf(cod_elemento) > -1) ? classicacaoEspecialIndicadores(cor_base?.[2]) : 'Médio', 
            hexadecimal: cor_base?.[2]
        };
    }
    else if (valor_para_comparar <= 80) {
        return {
            classificacao: ([33,34,38]?.indexOf(cod_elemento) > -1) ? classicacaoEspecialIndicadores(cor_base?.[isInvertido(isCorInvertida, 3, 1)]) : 'Alto', 
            hexadecimal: isInterpretado ? (cor_base?.[isInvertido(isCorInvertida, 3, 1)]) : isInvertido(isCorInvertida, "#e22626", '#2ecc71')
        };       
    }
    else {
        return {
            classificacao: ([33,34,38]?.indexOf(cod_elemento) > -1) ? classicacaoEspecialIndicadores(cor_base?.[isInvertido(isCorInvertida, 4, 0)]) : 'Muito alto', 
            hexadecimal: isInterpretado ? (cor_base?.[isInvertido(isCorInvertida, 4, 0)]) : isInvertido(isCorInvertida, "#e22626", "#2ecc71")
        };          
    }
}

export function tabela_valores(valores: typeTabelaValores): {descricao:'Mínima'|'Média'|'Máxima',nota:string,valor:string}[] {    

    let { nota_minima, nota_media, nota_maxima, cores_do_mapa, isIndicadores, cod_elemento, isPrescricao, area_talhoes, isCorInvertida } = valores;
    let is_tres_cores = (cores_do_mapa?.length) === 3 && isIndicadores && ([33, 34, 38]?.indexOf(cod_elemento) > -1);   
    

    function legenda3Cores(descricao: string) {
    
        let tres_cores = {
            Mínima: isCorInvertida ? cores_do_mapa?.[2] : cores_do_mapa?.[0],
            Média:  cores_do_mapa?.[1],
            Máxima: isCorInvertida ? cores_do_mapa?.[0] : cores_do_mapa?.[2],
        }
    
        function classicacaoEspecialIndicadores(hexadecimal_comparativo: string) { //NOSONAR
            let legendas = legendas_mapa_indicadores?.[cod_elemento];
            const cartaEncontrada = legendas?.find(item => item?.hexadecimal === hexadecimal_comparativo);
    
            return cartaEncontrada ? cartaEncontrada.carta : "";
        }
    
        return classicacaoEspecialIndicadores(tres_cores?.[descricao])
    }

    function valorDaNotaMedia(valor_da_nota: string): string | number {

        if (isPrescricao) {
            let toneladas = (Number(valor_da_nota) * area_talhoes) / 1000;
            let valor_final = toneladas >= 1 ? `Total de ${toneladas?.toFixed(2)} t` : `Total de ${(toneladas * 1000)?.toFixed(2)} kg`
    
            return `${Number(valor_da_nota)?.toFixed(1)} ║ ${valor_final}`
        }

        return valor_da_nota
    } 
    
    
    return [
        { 
            descricao: 'Mínima', 
            valor: is_tres_cores ? legenda3Cores('Mínima') : legendaClassificacao('Mínima', valores).classificacao, 
            nota: isPrescricao ? Number(nota_minima)?.toFixed(1) : nota_minima 
        },
        {
            descricao: 'Média', 
            valor: is_tres_cores ? legenda3Cores('Média') : legendaClassificacao('Média', valores).classificacao, 
            nota: String(valorDaNotaMedia(nota_media))
        },
        {
            descricao: 'Máxima', 
            valor: is_tres_cores ? legenda3Cores('Máxima') : legendaClassificacao('Máxima', valores).classificacao, 
            nota: isPrescricao ? Number(nota_maxima)?.toFixed(1) : nota_maxima
        }
        
    ];
};

